import { useMemo } from 'react';

import { collection, orderBy, Query, query } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { useData } from '../contextProviders/DataProvider';
import { firestore } from '../firebase';
import Competition from '../types/Competition';

export default function useCompetitions() {
  const { userState } = useData();

  const competitionsQuery = useMemo(() => {
    if (userState.status !== 'ready' || !userState.userProfile) return null;
    return query(collection(firestore, 'competition') as Query<Competition>, orderBy('name'));
  }, [userState.status, userState.userProfile]);

  const [competitions, isCompetitionsLoading, competitionsError] = useCollectionData<Competition>(competitionsQuery);

  if (userState.status === 'logged_out') {
    return {
      competitions: null,
      isCompetitionsLoading: false,
      competitionsError: new Error('User must be logged in to view competitions'),
    };
  }

  return {
    competitions: competitions ?? [],
    isCompetitionsLoading:
      isCompetitionsLoading ||
      userState.status === 'authenticating_user' ||
      userState.status === 'authenticating_profile' ||
      userState.status === 'authenticating_memberships',
    competitionsError,
  };
}
